'use client';

import { Home } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { Button } from '@/components/ui/button';
import { logger } from '@/lib/logger';

export default function NotFound() {
  const router = useRouter();

  useEffect(() => {
    // Log 404 for monitoring
    logger.warn('404 Page Not Found', {
      path: window.location.pathname,
      referrer: document.referrer,
    });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center max-w-2xl mx-auto px-6">
        <h1 className="text-7xl md:text-8xl font-bold text-foreground/50 mb-4">
          404
        </h1>
        <h2 className="text-3xl font-bold mb-4">Page Not Found</h2>
        <p className="text-base text-gray-400 mb-8 max-w-xl mx-auto">
          The page you are looking for does not exist or has been moved. Let us
          get you back on track.
        </p>
        <div className="flex gap-4 justify-center">
          <Button onClick={() => router.push('/')} size="lg">
            <Home className="w-4 h-4 mr-2" />
            Go Home
          </Button>
          <Button onClick={() => router.back()} variant="outline" size="lg">
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
